/* eslint-disable no-unused-vars */
import { v4 as uuidv4 } from 'uuid'
import isNil from 'lodash/isNil'
import { getExperimentsStorage } from './experiments-storage'

const createVariantBucket = (numVariants, string) => {
  return hashCode(string) % numVariants
}

/**********************************************
Experiment Name: Single Page Menu
Description: Split out all users to measure impact Single Page Menu has on Conversion Rate
Variants:
  0: Control - No Treatment - 50%
  1: Single Page Menu is visible - 50%
**********************************************/
export const XP_SINGLE_PAGE_MENU = {
  experimentName: 'xp-single-page-menu',
  flagName: 'oo-v3-single-page-menu',
  useInitVariant () {
    const experimentStorage = getExperimentsStorage()
    const storedVariant = experimentStorage.get(XP_SINGLE_PAGE_MENU.experimentName)
    if (!isNil(storedVariant)) {
      return storedVariant
    }
    const variant = createVariantBucket(2, uuidv4())
    experimentStorage.set(XP_SINGLE_PAGE_MENU.experimentName, variant)
    return variant
  },
  getTreatment (variant) {
    return variant
  }
}

// Basic port of Java's String.hashCode. Not particularly tuned for handling collisions,
// which in this case is not too important
function hashCode (s) {
  for (var i = 0, h = 0; i < s.length; i++) { h = Math.imul(31, h) + s.charCodeAt(i) | 0 }
  return Math.abs(h)
}
